import { render, staticRenderFns } from "./MediaTab.vue?vue&type=template&id=a520742e&scoped=true&"
import script from "./MediaTab.vue?vue&type=script&lang=js&"
export * from "./MediaTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a520742e",
  null
  
)

export default component.exports